/* eslint-disable import/prefer-default-export */
const availableAtScreenSize = () => (
  window.innerWidth > 500
);

export {
  availableAtScreenSize,
};
/* eslint-enable import/prefer-default-export */
